import styled from 'styled-components';

const Heading = styled.div`
  font-size: 32px;
  padding-bottom: 24px;
`;

export default Heading;
